import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton';
import Container from '@mui/material/Container'
import { DashboardContent } from '../Dashboard/DashboardLayout/DashboardLayout.styles'
import MobileHeader from '../../components/MobileHeader/MobileHeader'
import { PageWrapper } from '../../styles/_var'
import { BackdropWrapper, DateRequestInfoWrapper } from '../Dashboard/DateRequests/DateRequests.styles'
import ScoreboardBanner from '../../assets/images/scoreboard_banner.jpg'
import { ActivityBackDrop } from '../Dashboard/PlanActivity/CreateActivity/CreateActivity.styles'
import Text from '../../components/Text';
import ScoreboardBody from './ScoreboardBody';
import useScoreboard from './useScoreboard';


const Scoreboard = () => {
  const {
    isLoading,
    isError,
    data,
    isReady,
    onParticipantAdded,
    isAddingParticipant,
    removeParticipant,
    onDeleteScoreboard,
    hasParticipants,
    hasWriteAccess,
    creatorUsername,
    scoreboardResults,
    onCreateScoreboardResult,
    isCreatingScoreboardResult,
    resultsPage,
    resultsPaginationInfo,
    hasPreviousResultsPage,
    hasNextResultsPage,
    gotoNextResultsPage,
    gotoPreviousResultsPage,
    isLoadingScoreboardResults,
    isErrorScoreboardResults,
    scoreboard_id,
    defaultNewResultLabel,
  } = useScoreboard()
  const scoreboardProps = {
    onParticipantAdded,
    isAddingParticipant,
    participants: data?.payload.scoreboard_participants || [],
    deleteParticipant: removeParticipant,
    hasParticipants,
    hasWriteAccess,
    onDeleteScoreboard,
    creatorUsername,
    scoreboardResults,
    onCreateScoreboardResult,
    isCreatingScoreboardResult,
    resultsPage,
    resultsPaginationInfo,
    hasPreviousResultsPage,
    hasNextResultsPage,
    gotoNextResultsPage,
    gotoPreviousResultsPage,
    isLoadingScoreboardResults,
    isErrorScoreboardResults,
    scoreboard_id,
    defaultNewResultLabel,
  }

  return (
    <DashboardContent isMobile>
      <MobileHeader style={{display: 'block'}} />
      <PageWrapper>
        <BackdropWrapper>
          <ActivityBackDrop backdrop={ScoreboardBanner} />
        </BackdropWrapper>
        <DateRequestInfoWrapper style={{top: -65}}>
          <Container>
            <Paper sx={{marginBottom: 3}}>
              <Box p={2}>
                <Text useDiv variant="medium" weight="bold" mb={1}>
                  {data?.payload.title || 'Scoreboard Title'}
                </Text>
                <Text useDiv variant="medium" mb={1}>
                  {data?.payload.description || 'Scoreboard Description'}
                </Text>
              </Box>
            </Paper>
            <Box>
              {isLoading && <LoadingSkeleton />}
              {isReady && <ScoreboardBody {...scoreboardProps} />}
              {isError && <FailedContent /> }
            </Box>
          </Container>
        </DateRequestInfoWrapper>
      </PageWrapper>
    </DashboardContent>
  )
}

export default Scoreboard

const LoadingSkeleton = () => {
  return (
    <Box p={2} sx={{top: -65, position: "relative"}}>
      <Box display="flex" flexDirection="row" columnGap={3} justifyContent="center">
        <Skeleton variant="rounded" height={40} width={120} />
        <Skeleton variant="rounded" height={40} width={120} />
      </Box>
      <Box mt={4}>
        <Skeleton variant="text" height={30} width={120} />
        <Skeleton variant="text" height={70} />
        <Skeleton variant="text" height={70} />
        <Skeleton variant="text" height={70} />
        <Skeleton variant="text" height={70} />
      </Box>
    </Box>
  ) 
}

const FailedContent = () => {
  return (
    <Box p={2} sx={{top: -65, position: "relative"}}>
      <Text variant="medium" weight="bold" color="error" useDiv>
        Failed to load scoreboard. Please try again later.
      </Text>
    </Box>
  )
}